import { trans } from '@spotahome/soyuz/client';

import { useModalHandle } from '../utils/withModalHandle';
import PlusValuePropositionModal from '../PlusValueProposition/PlusValuePropositionModal';
import Link from '../Link';

const PlusLabelDescription = () => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle({
    removeScrollbarCSL: true
  });

  const handleOnClick = e => {
    e.preventDefault();
    handleModalOpen();
  };

  return (
    <>
      {trans('plus.value.proposition.description')}{' '}
      <strong>
        <Link
          onClick={handleOnClick}
          data-test="plus-value-proposition-open"
          size="medium"
          theme="dark"
        >
          {trans('plus.value.proposition.see-more')}
        </Link>
      </strong>
      <PlusValuePropositionModal
        isOpen={isModalOpen}
        handleClose={handleModalClose}
      />
    </>
  );
};

export default PlusLabelDescription;
